import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-autocomplete-dialog',
  templateUrl: './t_autocomplete-dialog.component.html',
  styleUrls: ['./autocomplete-dialog.component.css']
})
export class AutocompleteDialogComponent implements OnInit {

  myControl: FormControl = new FormControl();

    public title: string;
    public options = [];
    public idOptions = [];

    filteredOptions: Observable<string[]>;

    
    constructor(
    public dialogRef: MatDialogRef<AutocompleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
    	this.title = data.title;
    	for(let id in data.options) {
    		let option = data.options[id];
    		this.options.push(option);
    		this.idOptions[option] = id;
    	}
    }


    ngOnInit() 
    {
      this.filteredOptions = this.myControl.valueChanges
         .startWith(null)
         .map(val => val ? this.filter(val) : this.options.slice());
   }

    filter(val: string): string[] 
    {
      let regExpFilter = new RegExp(val, 'i');
      return this.options.filter((option) => regExpFilter.test(option));
   }

   optionSelected(e) 
   {
   	this.dialogRef.close(this.idOptions[e.option.value]);
   }

}
